module.exports = __webpack_public_path__ + "static/img/img18.ac1c1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img18.png
// module id = UFqv
// module chunks = 1